import { axios, Response } from '../index'
import { GetConfigurationPublicationsResponse } from './get-configurationPublications'

const checkConfigurationPublications = (
  publisherId: string
): Response<GetConfigurationPublicationsResponse> => {
  return axios.put(`/v1/publisher-settings/${publisherId}`)
}

export default checkConfigurationPublications
